module.exports = __webpack_public_path__ + "static/a-xx-170-art-e10d3cfb6ba91c43a89511682f589284.jpg";